import { render, staticRenderFns } from "./ComplianceTrafficLight.vue?vue&type=template&id=79cbc2a1&scoped=true"
import script from "./ComplianceTrafficLight.vue?vue&type=script&lang=js"
export * from "./ComplianceTrafficLight.vue?vue&type=script&lang=js"
import style0 from "./ComplianceTrafficLight.vue?vue&type=style&index=0&id=79cbc2a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cbc2a1",
  null
  
)

export default component.exports